export const computeCandidateTrustScore = (storeState) => {
  let trustScore = 50;

  // 1. Profile Photo (3 points)
  let profilePhotoScore = storeState.profilePhoto?.path ? 3 : 0;
  trustScore += profilePhotoScore;

  // 2. Basic Info (12 points)
  let basicInfoScore = 0;
  if (storeState.about) basicInfoScore += 2;
  if (storeState.summary?.prompt && storeState.summary?.answer) basicInfoScore += 2;
  if (hasCandidateLocationInformation(storeState)) basicInfoScore += 1;
  if (storeState.willingToRelocate) basicInfoScore += 1;
  if (storeState.remote) basicInfoScore += 1;
  if (storeState.interestedIn?.length) basicInfoScore += 1;
  if (storeState.industries?.length) basicInfoScore += 1;
  if (storeState.fullTime?.length) basicInfoScore += 1;
  if (storeState.availability?.length) basicInfoScore += 1;
  if (storeState.desiredHourlyPay) basicInfoScore += 1;
  trustScore += basicInfoScore;

  // 3. Exceptional Abilities (5 points)
  let exceptionalAbilitiesScore = storeState.exceptionalAbility
  && storeState.exceptionalAbility.length === 3
  && storeState.exceptionalAbility.every(Boolean) ? 5 : 0;
  trustScore += exceptionalAbilitiesScore;

  // 4. Videos (12 points)
  let videosScore = 0;
  if (storeState.profileVideo1 && storeState.profileVideo1.path && storeState.profileVideo1.prompt) videosScore += 6;
  if (storeState.profileVideo2?.path && storeState.profileVideo2.path && storeState.profileVideo2.prompt) videosScore += 6;
  trustScore += videosScore;

  // 5. Skills & Accomplishments (4 points)
  let skillsAccomplishmentsScore = 0;
  if (storeState.skills?.length) skillsAccomplishmentsScore += 2;
  if (storeState.accomplishments?.length) skillsAccomplishmentsScore += 2;
  trustScore += skillsAccomplishmentsScore;

  // 6. Career Passport (10 points)
  let careerPassportScore = storeState.careerPassport?.length ? 10 : 0;
  trustScore += careerPassportScore;

  // 7. Education & Badges (4 points)
  let educationBadgesScore = storeState.education?.length ? 4 : 0;
  trustScore += educationBadgesScore;

  return {
    profilePhotoScore: profilePhotoScore,
    basicInfoScore: basicInfoScore,
    exceptionalAbilitiesScore: exceptionalAbilitiesScore,
    videosScore: videosScore,
    skillsAccomplishmentsScore: skillsAccomplishmentsScore,
    careerPassportScore: careerPassportScore,
    educationBadgesScore: educationBadgesScore,
    overall: trustScore
  };
};

export const computeCompanyTrustScore = (storeState) => {
  let trustScore = 50;

  // 1. Basic Info (8 points)
  let basicInfoScore = 0;
  if (storeState.description) basicInfoScore += 5;
  if (storeState.industries?.length) basicInfoScore += 1;
  if (storeState.companySize) basicInfoScore += 1;
  if (storeState.yearFounded) basicInfoScore += 1;
  trustScore += basicInfoScore;

  // 2. Values (15 points)
  let valuesScore = 0;
  if (storeState.missionStatement) valuesScore += 8;
  if (storeState.coreValues) valuesScore += 7;
  trustScore += valuesScore;

  // 3. Company Colors, Logo, Banner (12 points)
  let visualsScore = 0;
  if (storeState.fileAvatar?.path) visualsScore += 4;
  if (storeState.fileLogo?.path) visualsScore += 4;
  if (storeState.fileBanner?.path) visualsScore += 4;
  trustScore += visualsScore;

  // 4. Company Media (15 points)
  let mediaScore = 0;
  if (storeState.video1?.path) mediaScore += 6;
  if (storeState.video2?.path) mediaScore += 4;
  const mediaFields = [
    storeState.fileImage1.path,
    storeState.fileImage2.path,
    storeState.fileImage3.path,
    storeState.fileImage4.path,
    storeState.fileImage5.path,
  ];
  const mediaFieldsLength = mediaFields.filter((field) => !!field).length;
  mediaScore += mediaFieldsLength;

  trustScore += mediaScore;

  return {
    basicInfoScore: basicInfoScore,
    valuesScore: valuesScore,
    visualsScore: visualsScore,
    mediaScore: mediaScore,
    overall: trustScore
  };
};
import {hasCandidateLocationInformation} from "./CandidateLocation.js";
